// Core component styles
const coreStyles={container:{display:'flex',flexDirection:'column',flexGrow:1}};/**
* Helper method to get the styles for Carousel component
* @param {Object} contextStyles - Context styles for the Carousel Component
*/const getStyles=function(){let contextStyles=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return{container:{...coreStyles.container,...contextStyles.container}};};export default getStyles;